(function () {
  // Half Past Fur — lock --announcement-height once on load and never
  // animate it on scroll. The original behaviour zeroed it out when the
  // bar left the viewport and rebuilt it on re-entry, which pushed every
  // subsequent section down when scrolling back to the top.

  const setStaticHeight = () => {
    const annBar = document.querySelector(".section-announcement");
    const h = annBar?.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty(
      "--announcement-height",
      `${h.toFixed(2)}px`
    );
  };

  const initAnnBar = () => {
    setStaticHeight();
    // Keep the variable accurate on resize (e.g. mobile rotate) but
    // never reset it from a scroll event.
    if (window.ResizeObserver) {
      const annBar = document.querySelector(".section-announcement");
      if (annBar) {
        const ro = new ResizeObserver(setStaticHeight);
        ro.observe(annBar);
      }
    }
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
